

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"width":"13","height":"13","viewBox":"0 0 13 13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, rest), ["\n", h('g', {"clip-path":"url(#svg-info-1n59Bi8)"}, ["\n", h('path', {"d":"M6.14062 1.30054C7.03389 1.30054 7.76062 2.02727 7.76062 2.92054C7.76062 3.8138 7.03389 4.54054 6.14062 4.54054C5.24735 4.54054 4.52062 3.8138 4.52062 2.92054C4.52062 2.02727 5.24735 1.30054 6.14062 1.30054ZM8.30062 12.1005H3.98062V11.1748H4.90634V6.54625H3.98062V5.62054H7.37491V11.1748H8.30062V12.1005Z","fill":"#342245"}, []), "\n"]), "\n", h('defs', {}, ["\n", h('clipPath', {"id":"svg-info-1n59Bi8"}, ["\n", h('rect', {"width":"12","height":"12","fill":"white","transform":"translate(0.140625 0.700562)"}, []), "\n"]), "\n"]), "\n"]);
};

        